import { Box, Fade, makeStyles, TextField, Typography } from '@material-ui/core';
import { useContext, useEffect, useState } from 'react';
import { transitionTimeout } from '../ClaimWizard';
import { separations } from '../../../../constants/StyleConstants';
import { ClaimContext } from '../../../../contexts/ClaimContext';
import SimpleKeyValueText from '../../../../components/UI/SimpleKeyValueText';
import clsx from 'clsx';
import { dateToStr } from '../../../../utils/DateUtils';
import ClaimsAPI from '../../../../services/ClaimsAPI';
import { AppContext } from '../../../../contexts/AppContext';
import AreaSelect from '../../../../components/AreaSelect';

const useStyles = makeStyles(theme => ({
  ...separations,
  root: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    width: '100%',
    '& .MuiOutlinedInput-multiline': {
      height: '100%',
      alignItems: 'flex-start',
    },
  },
  msgWrapper: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'center',
  },
  msgBox: {
    backgroundColor: theme.palette.primary.light,
    borderRadius: 4,
    whiteSpace: 'nowrap',
  },
  descriptionInput: {
    height: '100%',
    margin: 0,
  },
}));

const ServicePageClaim = ({ servicePage }) => {
  const classes = useStyles();
  const { showError, showWarning } = useContext(AppContext);
  const { setStepElements, setOpenBackDrop, selectedClaimId } = useContext(ClaimContext);
  const [transIn, setTransIn] = useState(true);
  const [description, setDescription] = useState('');
  const [area, setArea] = useState('');

  useEffect(() => {
    const step = {
      stepNumber: 2,
      backButtonText: servicePage ? 'Cancelar y elegir otra hoja' : 'Cancelar y Volver',
      finishButtonText: 'Iniciar reclamo',
      finishButtonAction: () => sendClaim(area, description),
      transition: {
        enter: () => setTransIn(true),
        exit: () => setTransIn(false),
      },
    };

    setStepElements(step.stepNumber, step);
  }, [area, description]);

  const handleChangeDescription = value => {
    if (value.isBlank()) {
      setDescription('');
    } else {
      setDescription(value);
    }
  };

  const validate = () => {
    let errors = [];
    const errorMessages = [];
    let i = 0;

    if ((errors[i++] = area.isBlank())) errorMessages.push('Debe seleccionar un área');
    if ((errors[i++] = description.isBlank())) errorMessages.push('Debe ingresar una descripción');

    const hasErrors = errors.some(e => e);

    hasErrors && showWarning(errorMessages);

    return !hasErrors;
  };

  const sendClaim = () => {
    return new Promise((resolve, reject) => {
      if (validate()) {
        setOpenBackDrop(true);

        const request = {
          idType: selectedClaimId,
          description: description,
          idArea: area,
          additionalInfo: {
            serviceRecordCode: servicePage?.serviceRecordCode,
          },
        };

        ClaimsAPI.startClaim(request)
          .then(res => {
            resolve();
          })
          .catch(error => {
            setOpenBackDrop(false);
            showError('Error al iniciar reclamo');
          });
      } else {
        reject();
      }
    });
  };

  return (
    <Fade in={transIn} timeout={transitionTimeout} unmountOnExit>
      <div className={classes.root}>
        <Typography className={classes.bottomSeparation} variant="subtitle2">
        {servicePage
            ? 'Se iniciará el reclamo por la hoja de servicio con los siguientes datos'
            : 'Se iniciará el reclamo por una hoja de servicio inexistente'}
        </Typography>
        <AreaSelect disableOptionAll style={{ marginBottom: '1em' }} value={area} setValue={setArea} title="Área a consultar" />
        <div className={clsx(classes.msgWrapper, classes.separationBetween)}>
          {servicePage && (
            <Box className={classes.msgBox} p={2}>
              <SimpleKeyValueText label="Nro. de hoja de servicio" value={servicePage.serviceRecordCode} />
              <SimpleKeyValueText label="Fecha" value={dateToStr(servicePage.dateServiceRecord)} />
              <SimpleKeyValueText label="Nro. Pedido de compra" value={servicePage.purchaseOrderCode} />
              <SimpleKeyValueText label="Texto" value={servicePage.text} />
            </Box>
          )}
          <TextField
            className={classes.descriptionInput}
            fullWidth
            margin="dense"
            rows={servicePage ? undefined : 6}
            rowsMax={20}
            id="description"
            multiline
            variant="outlined"
            label="Descripción"
            onChange={e => handleChangeDescription(e.target.value)}
            value={description}
          />
        </div>
      </div>
    </Fade>
  );
};

export default ServicePageClaim;
